module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_components/alert.component.html
// module id = ./src/app/_components/alert.component.html
// module chunks = main